import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Activity, Scenario } from '@bingads-webui-react/hoc-with-signal';
import { MonthPicker } from '@bingads-webui-campaign-react/budget-center-component';
import { withComponentErrorLogging } from '@bingads-webui-campaign-react/global-error-options';
import { SecondaryNavigationExpandButton } from '@bingads-webui-campaign-react/secondary-navigation-expand-button';
import { navRefreshSiteMap, withSiteMap } from '@bingads-webui-campaign-react/with-site-map';
import { ScopeBarLeftContent } from '@bingads-webui-fluent-component/scope-selector-menu';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { processorSet } from '@bingads-webui-react/with-site-map';

import { getBudgetCenterSubPageMenuStyles } from './styles/budget-center-sub-page-style';

const ExpandButton = withComponentErrorLogging(withSiteMap(SecondaryNavigationExpandButton, processorSet.navRefresh, navRefreshSiteMap), 'NavigationRefreshSecondaryNavigationExpandButton');

class BudgetCenterSubPageMenu extends React.Component {
  static defaultProps = {};

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {
    const { i18n, classes } = this.props;

    return (
      <Scenario name="budget-center-ui-next">
        <Activity name="budget-center-sub-page-menu">
          <div
            className={classnames('budget-center-menu-bar', classes.BudgetCenterMenuBar)}
          >
            <ScopeBarLeftContent className={classes.LeftContent}>
              <ExpandButton />
              <div id="budget-center-campaign-selector-dropdown" />
            </ScopeBarLeftContent>
            <MonthPicker i18n={i18n} />
          </div>
        </Activity>
      </Scenario>
    );
  }
}

export const StyledBudgetCenterSubPageMenu = withI18nConsumer(withDefaultStyles(BudgetCenterSubPageMenu, getBudgetCenterSubPageMenuStyles));

BudgetCenterSubPageMenu.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  classes: PropTypes.shape({
    BudgetCenterMenuBar: PropTypes.shape({}),
    LeftContent: PropTypes.shape({}),
  }).isRequired,
};
